import ToastError from "./components/Common/ToastError/ToastError";
import { useEffect } from "react";
import "./App.scss";
import RootRoute from "./views/Routes/RootRoute";
import { useDispatch, useSelector } from "react-redux";
import { setThemeStylesHandler } from "./store/actions/actionHandlers/commonActionHandler";
import Loader from "./components/Common/Loader/Loader";
import { msalConfig } from "./utils/msalConfig";
import * as msal from "@azure/msal-browser";
import { logoutAction } from "./store/actions/actionCreators/loginActionCreator";
import { domains, isMatchingDomain } from "./utils/ltimSSOLoginCondition";
import { endTrackedSessionOnPageExit } from "./utils/sessionManager";

function App() {
  const dispatch = useDispatch();

  const commonState = useSelector((state) => state.commonReducer);
  const { pageLoader, colors } = commonState;

  useEffect(() => {
    const themeData =
      !!localStorage.getItem("themeData") &&
      JSON.parse(localStorage.getItem("themeData"));
    if (!!themeData || !colors?.theme) {
      dispatch(setThemeStylesHandler(themeData));
    }
  }, [dispatch, colors?.theme]);

  // End the tracked session when the tab is truly closed.
  // `pagehide` fires for both refresh and tab close, so we set a
  // sessionStorage flag (_pageHiding) here. sessionStorage survives a page
  // refresh but is wiped when the tab closes, letting HeaderProfile
  // distinguish between the two cases and skip the lastLoginTime API
  // call on refresh (which would incorrectly update "Last Visited").
  useEffect(() => {
    const handlePageHide = () => {
      try { sessionStorage.setItem("_pageHiding", "1"); } catch (_) {}
      endTrackedSessionOnPageExit();
    };
    window.addEventListener("pagehide", handlePageHide);
    return () => window.removeEventListener("pagehide", handlePageHide);
  }, []);

  useEffect(() => {
    if (isMatchingDomain(domains) && !localStorage.getItem("token")) {
      const handleStorageEvent = (event) => {
        if (event.key === "logout") {
          // Perform logout actions
          const msalInstance = new msal.PublicClientApplication(msalConfig);
          localStorage.clear();
          sessionStorage.clear();
          dispatch(logoutAction());
          msalInstance.logoutRedirect();
        }
      };

      window.addEventListener("storage", handleStorageEvent);

      return () => {
        window.removeEventListener("storage", handleStorageEvent);
      };
    }
  }, [dispatch]);
  return (
    <div className="App">
      <RootRoute />
      <ToastError />
      {pageLoader && <Loader page />}
    </div>
  );
}

export default App;
